export default __webpack_public_path__ + "static/media/04.bcd21c2b.jpg";